import { combineReducers } from 'redux';
import { gameUIReducer } from './gameUIReducer';
import { popupsReducer } from './popupsReducer';

export const uiRootReducer = combineReducers({
  gameUI: gameUIReducer,
  popups: popupsReducer
});

export type UIRootState = ReturnType<typeof uiRootReducer>; 